import React, { useState } from 'react';
import { Container, Typography, Box, Divider, Tabs, Tab } from '@mui/material';
import TestimonialList from '../components/testimonials/TestimonialList';
import TestimonialForm from '../components/testimonials/TestimonialForm';
import UserTestimonials from '../components/testimonials/UserTestimonials';
import { useAuthStore } from '../store/authStore';

const TestimonialsPage = () => {
  const { user } = useAuthStore();
  const [activeTab, setActiveTab] = useState(0);
  
  const handleTestimonialSuccess = () => {
    // Refresh testimonials after successful submission
    window.location.reload();
  };
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Отзывы наших клиентов
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          Узнайте, что говорят о нас клиенты, которые уже воспользовались нашими услугами
        </Typography>
      </Box>

      {/* DISABLED: табы и форма отзывов скрыты, показываем только список */}
      <Box sx={{ mt: 4 }}>
        <TestimonialList />
      </Box>
    </Container>
  );
};

export default TestimonialsPage;
